module.exports = __webpack_public_path__ + "static/img/wellbore1.5823d01a.png";